import { useEffect } from 'react';
import { ReactComponent as CloseRed } from '../../../../images/close-red.svg';

import { useAppDispatch } from '../../../../App/redux/store';
import { modalsActions } from '../../modalsSlice';
import styles from './modal.module.scss';

function Modal({ children }: IChildren) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.modal}>
      <button
        type="button"
        className={styles.modalClose}
        onClick={() => dispatch(modalsActions.reset())}
      >
        <CloseRed />
      </button>

      {children}
    </div>
  );
}

export default Modal;
